import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-vclaim";

async function create(data) {
  const response = await http.postData("/sep", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response;
}

async function riwayat(nomor: string, tgl_awal, tgl_akhir) {
  const response = await http
    .getData(
      // `/peserta/history?nokartu=${nomor}&tgl_awal=${tgl_awal}&tgl_akhir=${tgl_akhir}`
      `/peserta/history?nokartu=${nomor}`
    )
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response.data;
}

async function getSEP(nomor) {
  const response = await http.getData(`/sep/${nomor}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function hapus(data) {
  const response = await http.deleteData("/sep", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response;
}

async function remove(noSep: string, username: string) {
  const params = {
    request: {
      t_sep: {
        noSep: noSep,
        user: username
      }
    }
  };

  const response = await http.deleteData("/sep", params).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response;
}

async function update(data) {
  const response = await http.putData("/sep", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response;
}

async function pengajuan(data) {
  const response = await http.postData("/pengajuan-sep", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function updateTglPulang(data) {
  const response = await http
    .putData(`/sep/update-tanggal-pulang`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getSepInternal(nomor) {
  const response = await http
    .getData(`/sep/${nomor}/sep-internal`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function deleteSepInternal(nomor, data) {
  const response = await http
    .deleteData(`/sep/${nomor}/sep-internal`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

function print(noSep) {
  window.open(`${http.getAPI()}/sep/${noSep}/cetak?size=esep`, "_blank");
}

async function sendToDigiclaim(noSep) {
  const response = await http
    .getData(`/sep/${noSep}/kirim-digiclaim`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

export default {
  create,
  riwayat,
  hapus,
  remove,
  print,
  getSEP,
  update,
  pengajuan,
  updateTglPulang,
  getSepInternal,
  deleteSepInternal,
  sendToDigiclaim
};
